import { useCallback, createContext, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigationFromState } from '@/utils/navigateBack';
import { playClickSound } from '@/utils/soundUtils';
import type { CampaignOfferPayload } from './campaignOfferCopy';

export const EMPTY_CAMPAIGN_OFFERS: CampaignOfferPayload = {
  offers: [],
  offerKey: '',
  popupDismissed: true,
};

export type CampaignBonusOffersValue = CampaignOfferPayload & {
  dismissPopup: () => Promise<void>;
  /** Replaces "Add money" navigation (the /dev/offers showcase stays on its page). */
  onAddMoney?: () => void;
};

export const CampaignBonusOffersContext = createContext<CampaignBonusOffersValue>({
  ...EMPTY_CAMPAIGN_OFFERS,
  dismissPopup: async () => {},
});

export function useCampaignBonusOffers() {
  return useContext(CampaignBonusOffersContext);
}

/** "Add money" from an offer: the guided flow, unless the player is already there. */
export function useOpenAddMoney() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { onAddMoney } = useCampaignBonusOffers();
  return useCallback(() => {
    playClickSound();
    if (onAddMoney) {
      onAddMoney();
      return;
    }
    if (pathname !== '/money/add') navigate('/money/add', navigationFromState(pathname));
  }, [navigate, onAddMoney, pathname]);
}
